/**
 * defa.views.RecipientGroupCollectionView
 * A CollectionView for RecipientGroupSnippets.
 * @version 1.0.0
 */

import { RecipientGroupSnippet } from './view-recipient-group-snippet';
import CollectionView            from '../../poppet/collection-view';

export const RecipientGroupCollectionView = CollectionView.extend( {
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	childView: RecipientGroupSnippet,
	
	childViewEvents: {
		'delete:recipient:group' : 'deleteRecipient'
	},
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	/**
	 * Triggers when the snippet trigger "delete:recipient:group".
	 * TODO! Is there a better way to do this, when there are two childviews that has the delete functionality?
	 * @void
	 */
	deleteRecipient: function(childview){
		this.trigger('delete:recipient:group', this, childview.model);
	},
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
} );
export default RecipientGroupCollectionView;